// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function DropDownEditor(props) {
  var onDropDownChange = props.onDropDownChange;
  var dropDown = props.dropDown;
  var compareChoices = Belt_List.cmpByLength(DropDown$ReactHooksTemplate.nonEmptyChoices(dropDown), DropDown$ReactHooksTemplate.choices(dropDown));
  var hasInvalidChoice = compareChoices !== 0;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    src: Image$ReactHooksTemplate.plusCircle
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Add choice"
                                  })
                            ],
                            className: "flex items-center justify-between gap-1 text-darkcharcoal"
                          }),
                      className: "bg-ghostwhite border border-gray-400\n          flex rounded p-2 text-sm mt-2" + (
                        hasInvalidChoice ? " disabled-input" : " "
                      ),
                      disabled: hasInvalidChoice,
                      onClick: (function (param) {
                          Curry._1(onDropDownChange, DropDown$ReactHooksTemplate.setChoice(DropDown$ReactHooksTemplate.makeChoice("", false, undefined), dropDown));
                        })
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(List.mapi((function (i, choice) {
                                  return JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: "Choice " + String(i + 1 | 0),
                                                      className: "sb-choice-label text-darkcharcoal text-sm font-medium"
                                                    }),
                                                JsxRuntime.jsx("input", {
                                                      className: (
                                                        DropDown$ReactHooksTemplate.getChoiceText(choice) === "" ? "h-40-px py-2 px-4 rounded bg-white border border-red-500 focus:border-red-500 text-xs w-full" : "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full"
                                                      ) + " sb-choice-input",
                                                      placeholder: "Enter Choice " + String(i + 1 | 0),
                                                      type: "text",
                                                      value: DropDown$ReactHooksTemplate.getChoiceText(choice),
                                                      onChange: (function ($$event) {
                                                          var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                          Curry._1(onDropDownChange, DropDown$ReactHooksTemplate.setChoice(DropDown$ReactHooksTemplate.setChoiceText(value, choice), dropDown));
                                                        })
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "sb-choice-delete h-12-px cursor-pointer",
                                                      src: Image$ReactHooksTemplate.trash,
                                                      onClick: (function (param) {
                                                          Curry._1(onDropDownChange, DropDown$ReactHooksTemplate.removeChoice(choice, DropDown$ReactHooksTemplate.choices(dropDown), dropDown));
                                                        })
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Label can't be blank",
                                                      className: DropDown$ReactHooksTemplate.getChoiceText(choice) === "" ? "sb-choice-error text-red-500 text-xs" : "hidden"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                            checked: DropDown$ReactHooksTemplate.getAllowNonSpecifiedText(choice),
                                                            label: "Enable non specified text",
                                                            handleChange: (function (param) {
                                                                Curry._1(onDropDownChange, DropDown$ReactHooksTemplate.setChoice(DropDown$ReactHooksTemplate.toggleAllowNonSpecifiedText(choice), dropDown));
                                                              }),
                                                            checkboxClassName: "custom_checkbox"
                                                          }),
                                                      className: "sb-choice-extra text-darkcharcoal text-sm font-light"
                                                    })
                                              ],
                                              className: "mb-4 sb-choice-row"
                                            }, RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(choice)));
                                }), DropDown$ReactHooksTemplate.choices(dropDown))),
                      className: "mb-7 mt-4"
                    })
              ]
            });
}

var make = DropDownEditor;

exports.make = make;
/* react/jsx-runtime Not a pure module */
